import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const pdfData = [
  {
    id: 1,
    title: "ERP Accounting, Inventory & Production",
    file: "/pdf/Mbook-Product-Presentation.pdf",
  },
  {
    id: 2,
    title: "CRM",
    file: "/pdf/MACO-CRM-Product-Overview.pdf",
  },
  {
    id: 3,
    title: "HRMS",
    file: "/pdf/Maco-HRMS-Product-Presentation.pdf",
  },
  {
    id: 4,
    title: "Asset Management Software",
    file: "/pdf/Macotech_Asset.pdf",
  },{
    id: 5,
    title: "Company Profile",
    file: "/pdf/Macotech Integrated Software Co..pdf",
  },
];

export const ProductPdf = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
  if (selectedPdf) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [selectedPdf]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <>
    <style>
        {`
.pdf-section {
  width: 100%;
  padding: 80px 20px;
  background: #f6f8fc;
}

.pdf-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* =========================
   HEADER
========================= */

.pdf-header {
  text-align: center;
  margin-bottom: 45px;
}

.pdf-subtitle {
  display: inline-block;
  margin-bottom: 10px;
  color: #e63946;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
}

.pdf-header h2 {
  margin: 0 0 12px;
  color: #172033;
  font-size: 38px;
  font-weight: 700;
}

.pdf-header p {
  margin: 0 auto;
  max-width: 600px;
  color: #697386;
  font-size: 16px;
  line-height: 1.6;
}

/* =========================
   PDF GRID
========================= */

.pdf-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
}

/* =========================
   CARD
========================= */

.pdf-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e6eaf0;
  border-radius: 18px;
  box-shadow: 0 8px 30px rgba(20, 30, 50, 0.07);
  transition: all 0.3s ease;
}

.pdf-card:hover {
  transform: translateY(-7px);
  border-color: transparent;
  box-shadow: 0 18px 45px rgba(20, 30, 50, 0.13);
}

/* =========================
   PDF PREVIEW
========================= */

.pdf-preview {
  min-height: 190px;
  display: flex;
  align-items: center;
  gap: 25px;
  padding: 30px;
  background: linear-gradient(
    135deg,
    #fff5f5 0%,
    #fff 50%,
    #f8f9ff 100%
  );
  border-bottom: 1px solid #edf0f5;
}

.pdf-icon {
  width: 85px;
  height: 105px;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 18px;
  background: #7f39e6;
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(230, 57, 70, 0.25);
}

/* folded corner */
.pdf-icon::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 25px;
  background: #ffffff;
  clip-path: polygon(100% 0, 0 0, 100% 100%);
}

.pdf-icon span {
  color: white;
  font-size: 16px;
  font-weight: 800;
}

.preview-text h3 {
  margin: 0 0 7px;
  color: #172033;
  font-size: 20px;
}

.preview-text p {
  margin: 0;
  color: #8992a3;
  font-size: 14px;
}

/* =========================
   CARD CONTENT
========================= */

.pdf-card-content {
  padding: 25px;
}

.pdf-card-content h3 {
  margin: 0 0 20px;
  color: #172033;
  font-size: 19px;
  font-weight: 650;
}

/* =========================
   BUTTONS
========================= */

.pdf-buttons {
  display: flex;
  gap: 12px;
}

.view-btn,
.download-btn {
  min-height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  border-radius: 9px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.25s ease;
}

.view-btn {
  flex: 1;
  border: 1px solid #1f53b8;
  background: #fff;
  color: #1f53b8
;
}

.view-btn:hover {
  background: #1f53b8;
  color: #fff;
}

.download-btn {
  flex: 1;
  border: 1px solid #1f53b8;
  background: #1f53b8;
  color: #fff;
}

.download-btn:hover {
  background: #1f53b8;
  border-color: #1f53b8;
  transform: translateY(-2px);
}


        .pdf-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;

  background: rgba(0, 0, 0, 0.8);

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;
}

.pdf-modal-content {
  width: 100%;
  max-width: 900px;
  height: 90vh;

  background: #525659;
  border-radius: 14px;

  overflow: hidden;

  display: flex;
  flex-direction: column;
}

/* HEADER */

.pdf-modal-header {
  height: 60px;
  min-height: 60px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 18px;

  background: #ffffff;
}

.pdf-modal-header h3 {
  margin: 0;

  max-width: calc(100% - 50px);

  font-size: 17px;
  color: #172033;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-btn {
  width: 38px;
  height: 38px;

  border: 0;
  border-radius: 50%;

  background: #f1f3f5;
  color: #222;

  font-size: 25px;

  cursor: pointer;
}

.close-btn:hover {
  background: #e63946;
  color: white;
}

/* PDF VIEWER */

.pdf-viewer {
  flex: 1;

  overflow-y: auto;
  overflow-x: hidden;

  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: #525659;
}

/* EACH PAGE */

.pdf-page {
  margin-bottom: 20px;

  background: white;

  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
}

.pdf-page canvas {
  display: block;

  max-width: 100%;
  height: auto !important;
}

/* LOADING */

.pdf-loading {
  color: white;
  padding: 30px;
  font-size: 16px;
}

.pdf-error {
  color: #ffb4b4;
  padding: 30px;
}

/* MOBILE */

@media (max-width: 768px) {

  .pdf-modal {
    padding: 0;
  }

  .pdf-modal-content {
    width: 100%;
    height: 100dvh;

    max-width: none;

    border-radius: 0;
  }

  .pdf-modal-header {
    height: 55px;
    min-height: 55px;

    padding: 0 12px;
  }

  .pdf-modal-header h3 {
    font-size: 14px;
  }

  .pdf-viewer {
    padding: 10px 5px;
  }

  .pdf-page {
    width: 100%;

    margin-bottom: 12px;
  }

  .pdf-page canvas {
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
  }
}

/* VERY SMALL MOBILE */

@media (max-width: 400px) {

  .pdf-viewer {
    padding: 5px 2px;
  }

  .pdf-page {
    margin-bottom: 8px;
  }

}
     /* =========================
   TABLET
========================= */

@media (max-width: 768px) {
  .pdf-section {
    padding: 60px 16px;
  }

  .pdf-header h2 {
    font-size: 30px;
  }

  .pdf-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .pdf-modal-content {
    height: 88vh;
  }
}

/* =========================
   MOBILE
========================= */

@media (max-width: 480px) {
  .pdf-section {
    padding: 45px 12px;
  }

  .pdf-header {
    margin-bottom: 30px;
  }

  .pdf-header h2 {
    font-size: 26px;
  }

  .pdf-header p {
    font-size: 14px;
  }

  .pdf-preview {
    min-height: 150px;
    padding: 22px;
  }

  .pdf-icon {
    width: 65px;
    height: 85px;
  }

  .preview-text h3 {
    font-size: 16px;
  }

  .pdf-card-content {
    padding: 18px;
  }

  .pdf-buttons {
    flex-direction: column;
  }

  .view-btn,
  .download-btn {
    width: 100%;
  }

  .pdf-modal {
    padding: 8px;
  }

  .pdf-modal-content {
    height: 90vh;
    border-radius: 10px;
  }

  .pdf-modal-header {
    min-height: 55px;
    padding: 0 12px;
  }

  .pdf-modal-header h3 {
    font-size: 15px;
  }
}
     `}
    </style>
    <section className="pdf-section">
      <div className="pdf-container">

        <div className="pdf-header">
          <span className="pdf-subtitle">DOCUMENTS</span>
          <h2>Product Documents</h2>
          <p>
            Explore our product brochures, catalogues and specifications.
          </p>
        </div>

        <div className="pdf-grid">
          {pdfData.map((pdf) => (
            <div className="pdf-card" key={pdf.id}>

              <div className="pdf-preview">
                <div className="pdf-icon">
                  <span>PDF</span>
                </div>

                <div className="preview-text">
                  <h3>{pdf.title}</h3>
                  <p>PDF Document</p>
                </div>
              </div>

              <div className="pdf-card-content">
                <h3>{pdf.title}</h3>

                <div className="pdf-buttons">

                  <button
                    className="view-btn"
                    onClick={() => {
                      setSelectedPdf(pdf);
                      setNumPages(null);
                    }}
                  >
                    👁 View PDF
                  </button>

                  <a
                    href={pdf.file}
                    download
                    className="download-btn"
                  >
                    ↓ Download
                  </a>

                </div>
              </div>

            </div>
          ))}
        </div>
      </div>

      {/* PDF MODAL */}

      {selectedPdf && (
        <div className="pdf-modal">

          <div className="pdf-modal-content">

            {/* HEADER */}

            <div className="pdf-modal-header">

              <h3>{selectedPdf.title}</h3>

              <button
                className="close-btn"
                onClick={() => setSelectedPdf(null)}
              >
                ×
              </button>

            </div>

            {/* PDF */}

            <div className="pdf-viewer">

              <Document
                file={selectedPdf.file}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={
                  <div className="pdf-loading">
                    Loading PDF...
                  </div>
                }
                error={
                  <div className="pdf-error">
                    Failed to load PDF
                  </div>
                }
              >

                {Array.from(
                  new Array(numPages),
                  (_, index) => (
                    <div className="pdf-page" key={index}>
                      <Page
                        pageNumber={index + 1}
                        width={Math.min(
                          window.innerWidth > 900
                            ? 800
                            : window.innerWidth - 30,
                          800
                        )}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </div>
                  )
                )}

              </Document>

            </div>

          </div>
        </div>
      )}
    </section>
    </>
  );
};